<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">渠道：</label>
        <el-select v-model="queryParams.channelId" clearable placeholder="筛选渠道">
          <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <label class="searchItemName">设备编号：</label>
        <el-input class="input-box" placeholder="设备编号" v-model="queryParams.deviceCode" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName">订单号：</label>
        <el-input class="input-box" placeholder="订单编号" v-model="queryParams.orderNumber" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName" style="width: 110px;">平台订单号：</label>
        <el-input class="input-box" placeholder="支付平台订单号" v-model="queryParams.tradeNumber" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName">付款人：</label>
        <el-input class="input-box" placeholder="姓名" v-model="queryParams.idName" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName">付款时间：</label>
        <el-date-picker v-model="queryParams.dateRange" type="daterange" value-format="yyyy-MM-dd"
          start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels
          :picker-options="pickerOptions"></el-date-picker>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="orderNumber" label="订单编号" width="150" align="center"></el-table-column>
      <el-table-column prop="deviceCode" label="设备编号" width="130" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道" width="150" align="center"></el-table-column>
      <el-table-column label="付款人" width="160" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.idName }}</div>
          <div>{{ maskIdNumber(scope.row.idNumber) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="业务类型" width="110" align="center">
        <template slot-scope="scope">
          <span :class="['biz-type', 'biz-type-' + bizTypeClass(scope.row.photoTypeId)]">{{ scope.row.photoTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" width="90" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.fee) }}</template>
      </el-table-column>
      <el-table-column label="支付方式" width="100" align="center">
        <template slot-scope="scope">
          <span :class="['pay-method', 'pay-method-' + payMethodClass(scope.row.payMethod)]">{{ formatPayMethod(scope.row.payMethod) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tradeNumber" label="平台订单号" min-width="160" align="center"></el-table-column>
      <el-table-column label="付款时间" width="170" align="center">
        <template slot-scope="scope">{{ formatDate(scope.row.payTime) }}</template>
      </el-table-column>
      <el-table-column label="支付状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.payStatus ? 'success' : 'info'">{{ scope.row.payStatus ? '已支付' : '未支付' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="退款" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.refund === 0 ? 'info' : 'warning'">{{ scope.row.refund === 0 ? '未退款' : '已退款' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button v-if="scope.row.payStatus && scope.row.refund === 0" type="warning" size="mini" plain @click="refund(scope.row)">退款</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      channels: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        channelId: '',
        deviceCode: '',
        orderNumber: '',
        tradeNumber: '',
        idName: '',
        dateRange: []
      },
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  created() {
    this.loadChannels()
    this.GetData()
  },
  methods: {
    formatDate(value) {
      if (!value) return ''
      const text = String(value)
      if (text.indexOf('1900-01-01') === 0 || text.indexOf('0001-01-01') === 0) return ''
      return text
    },
    formatPayMethod(value) {
      const method = Number(value)
      if (method === 1) return '微信'
      if (method === 2) return '支付宝'
      return '其他'
    },
    payMethodClass(value) {
      const method = Number(value)
      if (method === 1 || method === 2) return method
      return 0
    },
    bizTypeClass(value) {
      const id = Number(value)
      if (id >= 1 && id <= 10) return id
      return 0
    },
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    loadChannels() {
      post(208, { channelName: '' }).then(response => {
        if (response.data.result == 0 && Array.isArray(response.data.data)) {
          this.channels = response.data.data
        }
      }).catch(() => {})
    },
    GetData() {
      const range = this.queryParams.dateRange || []
      const loading = this.openLoading()
      post(503, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        channelId: this.queryParams.channelId || 0,
        deviceCode: (this.queryParams.deviceCode || '').trim(),
        orderNumber: (this.queryParams.orderNumber || '').trim(),
        tradeNumber: (this.queryParams.tradeNumber || '').trim(),
        idName: (this.queryParams.idName || '').trim(),
        beginTime: range[0] || '',
        endTime: range[1] || ''
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    refund(row) {
      this.$prompt(`确认对订单「${row.orderNumber}」退款 ${this.formatMoney(row.fee)} 元？请输入退款原因`, '退款', {
        confirmButtonText: '退款',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '退款原因不能为空'
      }).then(({ value }) => {
        const loading = this.openLoading()
        post(504, { objId: row.id, reason: (value || '').trim() }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success(response.data.message || '退款成功')
            this.GetData()
          } else {
            this.$message.error('退款失败：' + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || '退款失败')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.pay-method,
.biz-type {
  font-weight: 600;
}
.pay-method-1 {
  color: #07c160;
}
.pay-method-2 {
  color: #1677ff;
}
.pay-method-0 {
  color: #909399;
}
.biz-type-0 {
  color: #909399;
}
.biz-type-1 {
  color: #409eff;
}
.biz-type-2 {
  color: #67c23a;
}
.biz-type-3 {
  color: #e6a23c;
}
.biz-type-4 {
  color: #f56c6c;
}
.biz-type-5 {
  color: #909399;
}
.biz-type-6 {
  color: #9b59b6;
}
.biz-type-7 {
  color: #16a085;
}
.biz-type-8 {
  color: #d35400;
}
.biz-type-9 {
  color: #2c3e50;
}
.biz-type-10 {
  color: #c0392b;
}
</style>
